import { render } from "./ExtraQuestionDropDown.vue?vue&type=template&id=275db8a7&scoped=true&mode=md"
import script from "./ExtraQuestionDropDown.vue?vue&type=script&lang=js"
export * from "./ExtraQuestionDropDown.vue?vue&type=script&lang=js"

import "./ExtraQuestionDropDown.vue?vue&type=style&index=0&id=275db8a7&lang=scss&scoped=true"

import exportComponent from "/Volumes/TRENTDEVELOPMENT/www/classmarker_pre_release_production/web_apps/test-interface/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-275db8a7"]])

export default __exports__